import { Router, RoutesRecognized } from '@angular/router';
import { omit as _omit } from 'lodash';
import { force } from 'notie';
import { filter } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "../location/location.token";
const NOTIFY_REDIRECTION_KEY = 'notifyRedirection';
export class EsDomainCheckService {
    constructor(router, location) {
        this.router = router;
        this.location = location;
    }
    notifyIfRedirected() {
        this.router.events
            .pipe(filter((event) => event instanceof RoutesRecognized), filter((event) => event.state.root.queryParams[NOTIFY_REDIRECTION_KEY]))
            .subscribe(event => {
            const queryParams = _omit(event.state.root.queryParams, NOTIFY_REDIRECTION_KEY);
            const url = event.url.substring(0, event.url.indexOf('?'));
            this.router.navigateByUrl(url, { queryParams });
            this.notify();
        });
    }
    notify() {
        const { protocol, host } = this.location;
        const url = `${protocol}//${host}`;
        force({
            type: 'warning',
            text: `<b>Notice:</b> You have been redirected to our new URL (<a href="${url}" target="_blank" style="color: white; text-decoration: underline; font-weight: bold;">${url}</a>), please save this URL in your browser to avoid any future inconvenience.`,
            buttonText: 'Ok'
        });
    }
}
EsDomainCheckService.ngInjectableDef = i0.defineInjectable({ factory: function EsDomainCheckService_Factory() { return new EsDomainCheckService(i0.inject(i1.Router), i0.inject(i2.LOCATION)); }, token: EsDomainCheckService, providedIn: "root" });
